<div class="hayat">
  <app-hayat-welcome></app-hayat-welcome>
  @for(info of dataInfo; track dataInfo){
    <app-hayat-info [data]="info"></app-hayat-info>
  }
</div>
